import { getNumberFromMoneyString } from '../../helpers/utils';
import { awsBucket, axios, BucketCredentials } from './core';
import { handleResponse, handleError } from './response';

const single = 'product';
const plural = 'products';

const productImages = `${single}/images`;

const addProduct = (product) =>
  axios
    .post(`/${single}/add`, product)
    .then(handleResponse)
    .then((data) => {
      if (data.success) {
        // temporary
        return {
          id: data.id,
          ..._formatProduct(data.product),
        };
      } else {
        throw new Error('Something went wrong');
      }
    })
    .catch(handleError);

const _formatProduct = (product) => {
  let processed = {
    ...product.data,
    ...product,
  };

  processed.priceString = processed.price;
  processed.price = getNumberFromMoneyString(processed.price);
  processed.rent_earnings_per_week = getNumberFromMoneyString(
    processed.rent_earnings_per_week
  );
  return processed;
};

const getProductsByStatus = (filter) =>
  axios
    .post(`/${plural}/get`, filter)
    .then(handleResponse)
    .then((data) => data?.map((d) => _formatProduct(d)))
    .catch(handleError);

const getProductsHistoryByStatus = (filter) =>
  axios
    .post(`/${plural}/get`, filter)
    .then(handleResponse)
    .then((data) => data.map((d) => _formatProduct(d)))
    .catch(handleError);

const getProductById = (id) =>
  axios
    .post(`/${single}/get`, { id })
    .then(handleResponse)
    .then((d) => _formatProduct(d))
    .catch(handleError);

const updateProduct = (product) =>
  axios
    .post(`/${single}/update`, product)
    .then(handleResponse)
    .catch(handleError);

const deleteProduct = (id) =>
  axios.post(`/${single}/delete`, id).then(handleResponse).catch(handleError);

const updateProductStatus = (statusData) =>
  axios
    .post(`/${single}/status/update`, statusData)
    .then(handleResponse)
    .catch(handleError);

const getProductCategories = () =>
  axios
    .post(`/${single}/categories/get`)
    .then(handleResponse)
    .catch(handleError);

const getProductColors = () =>
  axios.post(`/${single}/colors/get`).then(handleResponse).catch(handleError);

const addProductImages = (productId, imageUrls) =>
  axios.all(
    imageUrls.map((imageUrl, index) =>
      axios.post(`/${productImages}/add`, {
        product_id: productId,
        img_url: imageUrl,
        img_primary: index === 0 ? true : false,
      })
    )
  );

const getProductImages = (id) =>
  axios
    .post(`/${productImages}/get`, {
      product_id: id,
    })
    .then(handleResponse)
    .catch(handleError);

const deleteProductImage = (id) =>
  axios
    .post(`/${productImages}/delete`, { id })
    .then(handleResponse)
    .then((data) => {
      // temporary
      return {
        success: data.toUpperCase() === 'OK',
      };
    })
    .catch(handleError);

const setPrimaryImage = (imageData) =>
  axios
    .post(`/${productImages}/primary/set`, imageData)
    .then(handleResponse)
    .catch(handleError);

const uploadImage = (obj) => {
  return new Promise(async (resolve, reject) => {
    if (obj.file) {
      const file = obj.file;
      let fileParts = file.name.split('.');
      let fileName = fileParts[0];
      let fileType = file.type;
      const theKey = `upload_files/${fileName}/${obj.id}`;

      const uploadUrl = await awsBucket.getSignedUrlPromise('getObject', {
        Bucket: BucketCredentials.bucketName,
        Key: theKey,
      });

      const params = {
        ACL: 'public-read',
        Key: theKey,
        ContentType: fileType,
        Body: file,
      };
      awsBucket
        .putObject(params)
        .on('httpUploadProgress', (evt) => {
          let progress = Math.round((evt.loaded / evt.total) * 100);
        })
        .send((err, data) => {
          if (err) reject('upload image', err);
          else
            resolve({
              img_url: uploadUrl.split('?')[0],
            });
        });
    } else {
      reject(Error('No file provided'));
    }
  });
};

const addReview = (data) =>
  axios
    .post(`/${single}/review/add`, data)
    .then(handleResponse)
    .catch(handleError);

const getReview = (data) =>
  axios
    .post(`/${single}/reviews/get`, data)
    .then(handleResponse)
    .catch(handleError);

const getIssues = (data) =>
  axios
    .post(`/${single}/issues/get`, data)
    .then(handleResponse)
    .catch(handleError);

const addRentalReturnReason = (data, callback) =>
  axios
    .post(`/${single}/rental_return_reasons/add`, data)
    .then((res) => {
      callback(res);
      handleResponse(res);
    })
    .catch((error) => {
      callback(error);
      handleError(error);
    });

const addRentalReturnNote = (data, callback) =>
  axios
    .post(`/${single}/rental_return_note/add`, data)
    .then((res) => {
      callback(res);
      handleResponse(res);
    })
    .catch((error) => {
      callback(error);
      handleError(error);
    });

const cancelRental = (data) =>
  axios
    .post(`/${single}/consignment/cancel`, data)
    .then(handleResponse)
    .catch(handleError);

const getProductStatuses = (data) =>
  axios
    .post(`/${single}/statuses/get`, data)
    .then(handleResponse)
    .catch(handleError);

const getSearchProduct = (data) => axios
.post(`/${single}/search/get`, data)
.then(handleResponse)
.catch(handleError);

const productAPI = {
  addProduct,
  getProductsByStatus,
  getProductsHistoryByStatus,
  getProductById,
  updateProduct,
  updateProductStatus,
  deleteProduct,

  getProductCategories,
  getProductColors,
  getProductStatuses,

  addProductImages,
  getProductImages,
  setPrimaryImage,
  deleteProductImage,
  uploadImage,
  getSearchProduct,

  addReview,
  getReview,
  getIssues,

  addRentalReturnReason,
  addRentalReturnNote,
  cancelRental,
};

export default productAPI;
